<div class="flex-align-center gap-M pad-XL-XL-0 w-100 border-box">
	<div class="flex-center title-icon radius-S">
		<img src="assets/icons/server-02.svg" class="filter-grey" height="24" alt=""/>
	</div>
	<div class="flex-column gap-XS">
		<span *ngIf="!data.serverInterface" class="font-L fw-700">{{ 'page.infrastructure.server.addAnInterface' | translate }}</span>
		<span *ngIf="!!data.serverInterface" class="font-L fw-700">{{ 'page.infrastructure.server.updateAnInterface' | translate }}</span>
		<span class="font-M fw-300">{{ 'page.infrastructure.server.updateAnInterfaceSubtitle' | translate }}</span>
	</div>
</div>
<div class="flex-column pad-XL gap-M">
	<div class="flex-column gap-M" style="height: 300px;">
		<div class="flex-column gap-XS">
			<div class="flex gap-XS">
				<span class="font-M fw-500 p-relative" [class.span-input-warning]="!isIpInNetworkRange() && serverInterfaceForm.get(form.IP_ADDRESS)!.valid" [class.grey]="isIpInNetworkRange() || serverInterfaceForm.get(form.IP_ADDRESS)!.invalid">
					{{ 'page.infrastructure.server.ipAddress' | translate }}*
					<div class="p-absolute" style="top: 1px; right: -20px;" *ngIf="!isIpInNetworkRange() && serverInterfaceForm.get(form.IP_ADDRESS)!.valid" [tooltip]="'page.infrastructure.network.serverNotInRange' | translate">
						<img src="assets/icons/warning.svg" width="13" class="filter-warning" alt=""/>
					</div>
				</span>
			</div>
			<div class="flex-column">
				<app-text-input
					[warning]="!isIpInNetworkRange() && serverInterfaceForm.get(form.IP_ADDRESS)!.valid"
					[input]="$any(serverInterfaceForm.get(form.IP_ADDRESS))"
					[disabled]="_saving">
				</app-text-input>
				<span class="text-red" style="text-align: end;" *ngIf="serverInterfaceForm.get(form.IP_ADDRESS)?.errors?.duplicateIp">
					{{ 'page.infrastructure.server.alreadyExistingIpAddress' | translate }}
				</span>
			</div>
		</div>
		<div class="flex-column gap-XS">
			<span class="font-M fw-500 grey">{{ 'page.infrastructure.server.connectedNetwork' | translate }}</span>
			<app-multi-select [inputControl]="$any(serverInterfaceForm.get(form.NETWORK))"
							  [disabled]=" _saving">
				<app-select-trigger appearance="field">{{$any(serverInterfaceForm.get(form.NETWORK)).value?.name || '-'}}</app-select-trigger>
				<app-select-option *ngFor="let network of networkList" [value]="network">{{network.name}}</app-select-option>
			</app-multi-select>
		</div>
		<div class="flex-column gap-XS">
			<span class="font-M fw-500 grey">{{ 'page.infrastructure.server.role' | translate }}*</span>
			<app-multi-select [inputControl]="$any(serverInterfaceForm.get(form.IS_PRIMARY))"
							  [disabled]="_saving || (data.serverInterface !== undefined && data.serverInterface.serverInterface.isPrimary) || (data.alreadyExistingIpAddresses.length <= 0)">
				<app-select-trigger appearance="field">{{$any(serverInterfaceForm.get(form.IS_PRIMARY)).value ? ('page.infrastructure.server.mainInterface' | translate) : ('page.infrastructure.server.secondaryInterface' | translate)}}</app-select-trigger>
				<app-select-option [value]="true">{{ 'page.infrastructure.server.mainInterface' | translate }}</app-select-option>
				<app-select-option [value]="false">{{ 'page.infrastructure.server.secondaryInterface' | translate }}</app-select-option>
			</app-multi-select>
		</div>
	</div>
	<div class="flex gap-M pad-top-M">
		<app-text-button type="stroked" class="w-50"
						 (click)="close(false)">
			{{'page.infrastructure.server.cancel'|translate}}
		</app-text-button>
		<app-text-button type="flat" class="w-50" [disabled]="serverInterfaceForm.invalid" [loading]="_saving" (click)="save()">{{ 'page.infrastructure.server.confirm' | translate }}</app-text-button>
	</div>
</div>
